import * as PIXI from 'pixi.js'

export class Node {
  constructor (node, geoMap) {
    this.id = node.id
    this.blobId = node.blobId
    this.longitude = node.longitude
    this.latitude = node.latitude
  }

  public initializeGraphics (project: any, container: PIXI.Container, pointerdown: () => void, radius: number): void {
    const coords = project([this.latitude, this.longitude])
    this.graphics = new PIXI.Graphics()
    this.graphics.beginFill(0xFF0000)
    this.graphics.drawCircle(coords.x, coords.y, radius)
    this.graphics.endFill()
    this.graphics.eventMode = 'dynamic'
    this.graphics.on('pointerdown', pointerdown)
    container.addChild(this.graphics)
  }
}
